import * as log from 'loglevel'

log.setLevel(process.env.REACT_APP_LOG_LEVEL)
const logger = log

export { logger }
